import { NumberUtils } from '../../../common/numberUtils';
import React from 'react';
import { SDPDivisionEnum } from '../../../enum/SDPDivisionEnum';

export interface MeterIndexDetailValueItemHeadProps {
  division?: SDPDivisionEnum;
  value?: number;
  icon: React.ReactNode;
  title: string;
}
export default function MeterIndexDetailValueItemHead({
  icon,
  value,
  title,
  division,
}: MeterIndexDetailValueItemHeadProps) {
  return (
    <div className="meter-index-detail__item__data__head">
      <div className="meter-index-detail__item__data__head__icon">{icon}</div>
      <div>
        <span className="meter-index-detail__item__data__head__value">
          {NumberUtils.parse(value, 2)}
        </span>
        &nbsp;
        <span className="meter-index-detail__item__data__head__unit">
          {SDPDivisionEnum.getUnit(division)}
        </span>
        <h4 className="meter-index-detail__item__data__head__title">{title}</h4>
      </div>
    </div>
  );
}
